import React from 'react'
import Box from '../../../../Box'

export default (type, element, content, children, key) => (
  <Box
    key={key}
    component='li'
    fontSize={22 / 16}
    fontFamily='Cabin'
    color='grey4'
    wordBreak='break-word'
  >
    {children}
  </Box>
)
